import { EstonianDistributionSettings } from './types';

export function computeEstonianDistributionTax(dividendBase: number, settings: EstonianDistributionSettings) {
  const warnings: string[] = [];
  if (settings.useSimple) {
    const rate = Math.max(0, settings.effectiveDistributionPct) / 100;
    return { tax: dividendBase * rate, warnings };
  }

  const { estonianCITRatePct, dividendPITPct, pitOffsetPct } = settings.detailed;
  const estonianRate = estonianCITRatePct / 100;
  const pitRate = dividendPITPct / 100;
  const offsetFactorRaw = pitOffsetPct / 100;
  if (offsetFactorRaw > 1 || offsetFactorRaw < 0) {
    warnings.push('Estonian PIT offset should be between 0% and 100%.');
  }
  const offsetFactor = Math.min(Math.max(offsetFactorRaw, 0), 1);

  const estonianCITPaid = dividendBase * estonianRate;
  const pitDue = Math.max(0, pitRate * dividendBase - offsetFactor * estonianCITPaid);
  const tax = estonianCITPaid + pitDue;

  return { tax, warnings };
}
